





























































































































import Vue from "vue";
import Component from "vue-class-component";
import Group, { STATUS, STATUS_NAME } from "@/model/group";
import QNotify from "@/common/qNotify";
import QErrors from "@/common/qErrors.vue";
import { compareWithKeys } from "@/common/utils";
import { GroupManagerService } from "@/common/api/services/GroupManagerService";

@Component({
  name: "GroupEdit",
  components: {
    QErrors,
  },
})
export default class GroupEdit extends Vue {
  public group: Group = new Group();
  public initData;
  public id: number = null;
  public title = "";
  public errors: any = {};
  public errorStyle = {
    maxWidth: "100%",
  };

  public statuses = [
    { key: STATUS.OPEN, value: STATUS_NAME[STATUS.OPEN] },
    { key: STATUS.PAUSE, value: STATUS_NAME[STATUS.PAUSE] },
    { key: STATUS.END, value: STATUS_NAME[STATUS.END] },
  ];

  async mounted() {
    this.id = Number.parseInt(this.$route.params.id);
    if (this.id) {
      await this.findGroup();
    }
    this.setTitle();
    this.initData = { ...this.group };
  }

  get isCreated() {
    return !this.id;
  }

  public isAdmin() {
    // todo ,implement after feature login
    return true;
  }

  public setTitle() {
    this.title = this.isCreated
      ? "グループの新規作成"
      : this.group.name + "の編集";
  }

  public async findGroup() {
    const result = await GroupManagerService.adminGroupShow({ id: this.id });
    this.group = new Group(result.data.group);
  }

  public async submit() {
    this.errors = {};

    let result;
    try {
      if (this.id) {
        result = await GroupManagerService.adminGroupEdit({
          id: this.group.id,
          name: this.group.name,
          spokes_name: this.group.spokes_name,
          spokes_email: this.group.spokes_email,
          request_approved: this.group.request_approved,
          status: this.group.status,
        });
      } else {
        result = await GroupManagerService.adminGroupCreate({
          name: this.group.name,
          spokes_name: this.group.spokes_name,
          spokes_email: this.group.spokes_email,
          request_approved: this.group.request_approved,
          status: this.group.status,
        });
      }
    } catch (error) {
      result = error;
    }

    if (result.status == "success") {
      QNotify.success({
        text: this.$t(
          this.isCreated ? "common.message.created" : "common.message.updated"
        ),
      });
      this.$router.push({ name: "admin.group" });
    } else if (result.status == "400") {
      this.errors = result.body.errors;
    } else {
      QNotify.error({
        text: result.body.message,
      });
    }
  }

  public cancel() {
    if (this.isChanged()) {
      this.$modal.showCancel({
        text: `${this.$t("common.modal.cancel_content")}`,
        confirmText: `${this.$t("common.buttons.yes")}`,
        cancelText: `${this.$t("common.buttons.no")}`,
        onConfirm: () => {
          this.$router.push({ name: "admin.group" });
        },
      });
    } else {
      this.$router.push({ name: "admin.group" });
    }
  }

  public isChanged() {
    return !compareWithKeys(this.group, this.initData, [
      "name",
      "spokes_name",
      "spokes_email",
      "request_approved",
      "status",
    ]);
  }

  public backGroup() {
    this.$router.push({ name: "admin.group" });
  }
}
